/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.ru>
 */
import 'APP_THEME/_common/base/index';

import 'APP_THEME/default/homepage/index.less';
import 'resources/less/themes/base/widgets/shopper_approved.less';

import 'APP_THEME/_common/main_page_blocks/index';

import facebook from 'assets/js/modules/api/facebook';
facebook.loadSdk();

import RoyalSlider from 'APP_THEME/_common/royal_slider/index';
const royalSlider = new RoyalSlider('.royalSlider');

$(function() {
    $('.seo-read-more').on('click', function(e) {
        e.preventDefault();
        $('.main-seo-info').removeClass('xs-seo-collapsed');
        $(this).hide();
    });
});
